// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.no-pagination-margin{
  margin-bottom:100px;
}
.back-color {
  background-color: #fafafa;
  height: 100%;
  width: 100%;
}

.open-events-parent {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 50px;
  border-bottom: 1px solid #eaeaea;
}

.dashboard-name {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  color: #424242;
  margin-bottom: 0 !important;
  margin-top: 15px !important;
}

.event-btn-pd {
  display: flex;
  flex-grow: 1;
  justify-content: end;
}
.enteredEvents h5 {
  font-family: "Rubik";
  font-style: Medium;
  font-size: 24px;
  line-height: 120%;
  vertical-align: Top;
  margin: 23px 0px 9px 0;
}
#parentDashboardtab {
  color: "#424242 !important";
}

.user-name {
  height: 100px;
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: 0px 15px 42px rgb(0 0 0 / 5%);
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 20px;
}

.MuiPaginationItem-root:hover {
  background-color: #fbb040 !important;
  color: white;
}

/* <---------------------------- media query for mpbile devices -------------------------------------> */
@media only screen and (min-width: 0px) and (max-width: 560px) {
  .open-events-parent {
    margin-bottom: 20px;
    height: 100px;
  }
  .pd-tabDiv {
    width: 100%;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .open-events-parent {
    margin-bottom: 20px;
    height: 100px;
  }
  .pd-tabDiv {
    width: 100%;
  }
  .EventsList-pd {
    margin: 0px !important;
  }
  .EventsList-pd .css-1pgd7le-MuiButtonBase-root-MuiTab-root {
    min-width: auto !important;
  }
  .user-name {
    padding: 20px 20px 20px 0;
  }
  .dashboard-name {
    font-size: 22px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .pd-tabDiv {
    width: 80%;
  }
  .eventListw .MuiTabs-flexContainer {
    margin-top: 41px;
  }
}
@media only screen and (min-width: 1024px) {
  .pd-tablist .css-1pgd7le-MuiButtonBase-root-MuiTab-root {
    padding: 10px 50px !important;
  }
  .pd-tabDiv {
    display: flex;
    width: 75%;
  }
}
@media screen and (min-width:1800px) {
  .helpImageDiv {
    position: fixed;
    bottom: 1vw !important;
    right: 1.5vw !important;
    /* height: 54px; */
}
}

@media screen and (max-width:560px) {
  .dropdown-toggle::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    color: #797979 !important;
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Parent/Dashboard/Dashboard.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,wGAAwG;AACxG;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;;AAEA;EACE;IACE,yDAA6Z;IAC7Z,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;IAChB,oCAAoC;EACtC;AACF","sourcesContent":["\n.no-pagination-margin{\n  margin-bottom:100px;\n}\n.back-color {\n  background-color: #fafafa;\n  height: 100%;\n  width: 100%;\n}\n\n.open-events-parent {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-bottom: 50px;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.dashboard-name {\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 120%;\n  color: #424242;\n  margin-bottom: 0 !important;\n  margin-top: 15px !important;\n}\n\n.event-btn-pd {\n  display: flex;\n  flex-grow: 1;\n  justify-content: end;\n}\n.enteredEvents h5 {\n  font-family: \"Rubik\";\n  font-style: Medium;\n  font-size: 24px;\n  line-height: 120%;\n  vertical-align: Top;\n  margin: 23px 0px 9px 0;\n}\n#parentDashboardtab {\n  color: \"#424242 !important\";\n}\n\n.user-name {\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-shadow: 0px 15px 42px rgb(0 0 0 / 5%);\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  padding: 20px;\n}\n\n.MuiPaginationItem-root:hover {\n  background-color: #fbb040 !important;\n  color: white;\n}\n\n/* <---------------------------- media query for mpbile devices -------------------------------------> */\n@media only screen and (min-width: 0px) and (max-width: 560px) {\n  .open-events-parent {\n    margin-bottom: 20px;\n    height: 100px;\n  }\n  .pd-tabDiv {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .open-events-parent {\n    margin-bottom: 20px;\n    height: 100px;\n  }\n  .pd-tabDiv {\n    width: 100%;\n  }\n  .EventsList-pd {\n    margin: 0px !important;\n  }\n  .EventsList-pd .css-1pgd7le-MuiButtonBase-root-MuiTab-root {\n    min-width: auto !important;\n  }\n  .user-name {\n    padding: 20px 20px 20px 0;\n  }\n  .dashboard-name {\n    font-size: 22px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .pd-tabDiv {\n    width: 80%;\n  }\n  .eventListw .MuiTabs-flexContainer {\n    margin-top: 41px;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .pd-tablist .css-1pgd7le-MuiButtonBase-root-MuiTab-root {\n    padding: 10px 50px !important;\n  }\n  .pd-tabDiv {\n    display: flex;\n    width: 75%;\n  }\n}\n@media screen and (min-width:1800px) {\n  .helpImageDiv {\n    position: fixed;\n    bottom: 1vw !important;\n    right: 1.5vw !important;\n    /* height: 54px; */\n}\n}\n\n@media screen and (max-width:560px) {\n  .dropdown-toggle::after {\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==);\n    color: #797979 !important;\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
